module.exports = __webpack_public_path__ + "static/media/psychedelicsActive.7441569b.svg";